import React from "react";

export default function GpsStatusCard({ title, value }) {
  return (
    <div className="rounded-2xl border border-gray-200 p-4 dark:border-white/10">
      <div className="text-xs uppercase text-gray-500">{title}</div>
      <div className="mt-1 text-2xl font-semibold">{value}</div>
    </div>
  );
}
